import { init } from 'expressionparser';

const tagParserLanguage = {
  AMBIGUOUS: {},
  INFIX_OPS: {
    AND: (a, b) => a() && b(),
    OR: (a, b) => a() || b(),
    '=': (a, b) => a() === b(),
    '>': (a, b) => a() > b(),
    '>=': (a, b) => a() >= b(),
    '<': (a, b) => a() < b(),
    '<=': (a, b) => a() <= b(),
  },
  PREFIX_OPS: {
    NOT: (expr) => !expr(),
  },
  PRECEDENCE: [['NOT'], ['AND'], ['OR']],
  GROUP_OPEN: '(',
  GROUP_CLOSE: ')',
  SEPARATOR: ' ',
  ESCAPE_CHAR: '',
  LITERAL_OPEN: '',
  LITERAL_CLOSE: '',
  SYMBOLS: ['(', ')'],
};

export interface ITagContextMatchesParams {
  tags?: Partial<
    Record<'user' | 'product' | 'temporary_address_remoteness_level', string[]>
  >;
  isAuthenticated?: boolean;
  orders?: number;
  isWebMobile?: boolean;
  isAppNative?: boolean;
  subscriptionTime?: number;
  isMember?: boolean;
}

export const tagContextMatches = (
  expression: string,
  {
    tags = {},
    orders,
    isWebMobile = false,
    isAppNative = false,
    subscriptionTime,
    isAuthenticated = false,
    isMember = false,
  }: ITagContextMatchesParams,
): boolean => {
  // If no expression is defined, it is available for all users
  if (!expression) {
    return true;
  }

  const parser = init(
    () => ({
      termDelegate: (term) => {
        term = term.toLowerCase();
        const n = parseInt(term, 10);

        switch (term) {
          case 'connected':
            return isAuthenticated;
          case 'member':
            return isMember;
          case 'orders':
            return orders || 0;
          case 'mobile':
            return isWebMobile;
          case 'desktop':
            return !isWebMobile && !isAppNative;
          case 'mobile-app':
            return isAppNative;
          case 'subscription-time':
            return subscriptionTime || 0;
          default: {
            // At this point, `term` should either be a tag or a literal number (the order count)
            if (!isNaN(n)) {
              return n;
            }

            if (!term.includes(':')) {
              return tags.user?.includes(term) ?? false;
            } else {
              const [tagSource, tagTerm] = term.split(':');

              return tags[tagSource]?.includes(tagTerm) ?? false;
            }
          }
        }
      },
      ...tagParserLanguage,
    }),
    (term) => term,
  );

  return !!parser.expressionToValue(expression);
};
